import FreeSamples from 'components/RwdBasket/RwdBasketLayout/BIBenefits/FreeSamples/FreeSamples';

export default FreeSamples;
